import { NavStyle } from '@crema/constants/AppEnums';
import Default from './DefaultLayout';

const Layouts = {
  [NavStyle.DEFAULT]: Default,
};
export default Layouts;
